import {AbstractControl} from '@angular/forms';

export enum ErrorMessageTypes {
  REQUIRED = 'required',
  NUMERIC = 'numeric',
  WHITESPACE = 'whitespace',
  YEAR = 'year',
  EMPTY_BUCKET = 'emptyBucket',
  MAX_LENGTH = 'maxLength',
  INVALID_OPTION = 'invalidOption'
}

export type ErrorMessageMap = Partial<Record<ErrorMessageTypes, string>>;

/**
 * Static class defining the user friendly error messages for forms in DAS 3.0.
 */
export class ErrorMessages {
  public static readonly [ErrorMessageTypes.REQUIRED]: string =
    'This is a mandatory field and must be completed before submission';

  public static readonly [ErrorMessageTypes.NUMERIC]: string = 'This field can only contain numeric characters';

  public static readonly [ErrorMessageTypes.WHITESPACE]: string = 'This field cannot contain only whitespace';

  public static readonly [ErrorMessageTypes.YEAR]: string = 'A year must be 4 numeric characters';

  public static readonly [ErrorMessageTypes.EMPTY_BUCKET]: string = 'At least one option must be selected';

  public static readonly [ErrorMessageTypes.MAX_LENGTH]: string = 'Max character length of 1000 has been exceeded';

  public static readonly [ErrorMessageTypes.INVALID_OPTION]: string = 'This option is prohibited';

  /**
   * Returns the user friendly error messages from the given form control.
   *
   * @param control {AbstractControl}   The form control to validate
   * @returns       {string[]}          The error messages
   */
  public static fromControl(control: AbstractControl, messages?: ErrorMessageMap): string[] {
    if (control && control.touched && control.errors) {
      return Object.keys(control.errors || {})
        .filter((error: ErrorMessageTypes) => !!control.errors[error] && ErrorMessages.hasOwnProperty(error))
        .map((error: ErrorMessageTypes) => (messages && messages[error]) || ErrorMessages[error]);
    } else {
      return [];
    }
  }

  private constructor() {
    // Prevent external instantiaion.
  }
}
